module.exports = __webpack_public_path__ + "components/advertise-header/static/c__card--2@2-ef6e9d452b07cc642c61174a9f944e10.jpg";